/**
 * Migration 002 — Investigation tables.
 * Extends the schema for Phase 2 AI investigation pipeline.
 *
 * New tables:
 * - investigations — Investigation state, scope, resource tracking
 * - investigation_entities — Links entities to investigations (M:N)
 * - collection_tasks — Per-source collection tasks within an investigation
 * - investigation_log — Detailed audit trail (replaces generic collection_log for investigations)
 * - entity_notes — Analyst annotations on entities
 */

export const MIGRATION_VERSION = 2;

export const MIGRATION_002_UP = `
CREATE TABLE IF NOT EXISTS investigations (
  id TEXT PRIMARY KEY,
  title TEXT NOT NULL,
  raw_query TEXT NOT NULL,
  decomposed TEXT,
  state TEXT NOT NULL DEFAULT 'init',
  desk_id TEXT NOT NULL,
  tier TEXT NOT NULL DEFAULT 'STANDARD',
  scope_contract TEXT,
  coverage TEXT,
  token_usage INTEGER DEFAULT 0,
  node_count INTEGER DEFAULT 0,
  edge_count INTEGER DEFAULT 0,
  started_at TEXT NOT NULL,
  completed_at TEXT,
  updated_at TEXT NOT NULL
);

CREATE TABLE IF NOT EXISTS investigation_entities (
  id TEXT PRIMARY KEY,
  investigation_id TEXT NOT NULL,
  entity_id TEXT NOT NULL,
  added_at TEXT NOT NULL,
  FOREIGN KEY (investigation_id) REFERENCES investigations(id),
  FOREIGN KEY (entity_id) REFERENCES entities(id),
  UNIQUE (investigation_id, entity_id)
);

CREATE TABLE IF NOT EXISTS collection_tasks (
  id TEXT PRIMARY KEY,
  investigation_id TEXT NOT NULL,
  source_id TEXT NOT NULL,
  query TEXT,
  expected_entity_types TEXT,
  status TEXT NOT NULL DEFAULT 'pending',
  raw_data TEXT,
  started_at TEXT,
  completed_at TEXT,
  error TEXT,
  FOREIGN KEY (investigation_id) REFERENCES investigations(id)
);

CREATE TABLE IF NOT EXISTS investigation_log (
  id TEXT PRIMARY KEY,
  investigation_id TEXT NOT NULL,
  timestamp TEXT NOT NULL,
  state TEXT NOT NULL,
  action TEXT NOT NULL,
  detail TEXT,
  agent_id TEXT,
  FOREIGN KEY (investigation_id) REFERENCES investigations(id)
);

CREATE TABLE IF NOT EXISTS entity_notes (
  id TEXT PRIMARY KEY,
  entity_id TEXT NOT NULL,
  text TEXT NOT NULL,
  created_at TEXT NOT NULL,
  FOREIGN KEY (entity_id) REFERENCES entities(id)
);

-- investigations indexes
CREATE INDEX IF NOT EXISTS idx_investigations_state ON investigations(state);
CREATE INDEX IF NOT EXISTS idx_investigations_desk_id ON investigations(desk_id);
CREATE INDEX IF NOT EXISTS idx_investigations_started_at ON investigations(started_at);

-- investigation_entities indexes (lookup by investigation or entity)
CREATE INDEX IF NOT EXISTS idx_inv_entities_investigation_id ON investigation_entities(investigation_id);
CREATE INDEX IF NOT EXISTS idx_inv_entities_entity_id ON investigation_entities(entity_id);

-- collection_tasks indexes
CREATE INDEX IF NOT EXISTS idx_collection_tasks_investigation_id ON collection_tasks(investigation_id);
CREATE INDEX IF NOT EXISTS idx_collection_tasks_status ON collection_tasks(status);

-- investigation_log indexes (queried by investigation, chronologically)
CREATE INDEX IF NOT EXISTS idx_inv_log_investigation_id ON investigation_log(investigation_id);
CREATE INDEX IF NOT EXISTS idx_inv_log_timestamp ON investigation_log(timestamp);

-- entity_notes indexes
CREATE INDEX IF NOT EXISTS idx_entity_notes_entity_id ON entity_notes(entity_id);
`;

export const MIGRATION_002_DOWN = `
-- Drop indexes
DROP INDEX IF EXISTS idx_entity_notes_entity_id;
DROP INDEX IF EXISTS idx_inv_log_timestamp;
DROP INDEX IF EXISTS idx_inv_log_investigation_id;
DROP INDEX IF EXISTS idx_collection_tasks_status;
DROP INDEX IF EXISTS idx_collection_tasks_investigation_id;
DROP INDEX IF EXISTS idx_inv_entities_entity_id;
DROP INDEX IF EXISTS idx_inv_entities_investigation_id;
DROP INDEX IF EXISTS idx_investigations_started_at;
DROP INDEX IF EXISTS idx_investigations_desk_id;
DROP INDEX IF EXISTS idx_investigations_state;

-- Drop tables
DROP TABLE IF EXISTS entity_notes;
DROP TABLE IF EXISTS investigation_log;
DROP TABLE IF EXISTS collection_tasks;
DROP TABLE IF EXISTS investigation_entities;
DROP TABLE IF EXISTS investigations;
`;
